export const GET_EVENTS = 'getEvents';
export const GET_USEREVENTS = 'getUserEvents';
export const ADD_EVENT = 'addEvent';
export const DELETE_EVENT = 'deleteEvent';
export const LOGIN = 'login';
export const CHECK_LOGIN = 'checkLogin';
export const LOGOUT = 'logout';
export const SET_TIMES = 'setTimes';